import React from 'react';
import gemIcon from '@/assets/gems/gem.png';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface GemsProps {
    with_text?: boolean;
    className?: string;
    size?: number;
}

export const Gems = ({ with_text = false, className = "", size = 16 }: GemsProps) => {
    const icon = (
        <img src={gemIcon} alt="Gem" style={{ width: size, height: size }} className="object-contain" />
    );

    return (
        <span className={`inline-flex items-center gap-1 ${className}`}>
            {!with_text ? (
                <Tooltip>
                    <TooltipTrigger asChild>
                        {icon}
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>Gems</p>
                    </TooltipContent>
                </Tooltip>
            ) : (
                icon
            )}
            {with_text && <span>Gems</span>}
        </span>
    );
};
